import { css } from 'styled-components';

// https://reactcommunity.org/react-transition-group/css-transition

const TransitionStyles = css`
  /* Fade up */
  .fadeup-enter {
    opacity: 0.01;
    transform: translateY(20px);
    transition: opacity 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94),
      transform 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .fadeup-enter-active {
    opacity: 1;
    transform: translateY(0px);
    transition: opacity 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94),
      transform 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  /* Fade down */
  .fadedown-enter {
    opacity: 0.01;
    transform: translateY(-20px);
    transition: opacity 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94),
      transform 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .fadedown-enter-active {
    opacity: 1;
    transform: translateY(0px);
    transition: opacity 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94),
      transform 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  /* Fade */
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    opacity: 1;
    transition: opacity 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .fade-exit {
    opacity: 1;
  }
  .fade-exit-active {
    opacity: 0;
    transition: opacity 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export default TransitionStyles;
